import { useState } from 'react';
import { useChatStore } from '../store/chatStore';
import { useAuthStore } from '../store/authStore';
import { sendMessage as sendMessageApi } from '../services/chatService';

export function useSendMessage() {
  const [inputValue, setInputValue] = useState('');
  const { addMessage, setLoading, isLoading } = useChatStore();
  const { aiToken, sessionId, auth } = useAuthStore();

  const sendMessage = async () => {
    const text = inputValue.trim();
    if (!text || isLoading || !aiToken || !sessionId || !auth) return;

    setInputValue('');
    addMessage('user', text);
    setLoading(true);

    try {
      const reply = await sendMessageApi(aiToken, sessionId, text, auth);
      addMessage('ai', reply.content);
    } catch {
      addMessage('ai', 'Something went wrong, please try again later.', true);
    } finally {
      setLoading(false);
    }
  };

  return { inputValue, setInputValue, sendMessage };
}
